<template>
    <div class="widget" :class="{ 'is-loading': isLoading }">
        <h3>Laatste projecten</h3>

        <div class="widget__inner">
            <ul>
                <li v-for="project in latestProjects" :key="project.id">
                    <router-link :to="{ name: 'viewProject', params: { id: project.id } }">{{ project.name }}</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { FETCH_LATEST_PROJECTS } from '@/store/modules/widgets'

	export default {
		data () {
			return {
				isLoading: true,
			}
		},

		computed: {
			...mapGetters([
				'latestProjects',
			]),
		},

		mounted () {
			this.fetchData()
		},

		methods: {
			fetchData () {
				this.$store.dispatch(FETCH_LATEST_PROJECTS).then(() => {
					this.isLoading = false
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
    ul{
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 0;
            border-bottom: 1px solid #e6e6e6;

            p {
                margin-bottom: 0;
            }

            strong {
                font-size: 22px;
            }

            &:first-child {
                padding-top: 0;
            }
        }
    }
</style>